import { c as _c } from "react/compiler-runtime";
import { useQualificationContext } from "@modules/booking/context/context";
import BookingCard from "../BookingCard";
import BookingLeadWall from "../BookingLeadWall";
import ProgressBar from "../ProgressBar";
import QualificationForm from "../QualificationForm";
const Qualification = () => {
  const $ = _c(8);
  const {
    stepId,
    handleLeadCreated,
    property,
    contactId,
    emailFromQuery,
    partnerId,
    clientMode
  } = useQualificationContext();
  if (stepId === "leadWall") {
    let t0;
    if ($[0] !== clientMode || $[1] !== contactId || $[2] !== emailFromQuery || $[3] !== handleLeadCreated || $[4] !== partnerId || $[5] !== property) {
      t0 = <BookingLeadWall onLeadCreated={handleLeadCreated} property={property} contactId={contactId} emailFromQuery={emailFromQuery} partnerId={partnerId} clientMode={clientMode} />;
      $[0] = clientMode;
      $[1] = contactId;
      $[2] = emailFromQuery;
      $[3] = handleLeadCreated;
      $[4] = partnerId;
      $[5] = property;
      $[6] = t0;
    } else {
      t0 = $[6];
    }
    return t0;
  }
  let t0;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BookingCard><ProgressBar /><QualificationForm showFirstStepText={true} /></BookingCard>;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
};
export default Qualification;